import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashBoardPage from "../DashBoardPage";
import MainDrawer from "../MainDrawer";
import ComingSoonPage from "../ComingSoonPage";
const Prometheus: React.FC = () => {
    return(<Box sx={{ display: "flex"}}>
    <MainDrawer index={"integrations"} />
{/* Helllo */}
    <Box sx={{display:"flex" , alignItems:"center", justifyContent:'center' ,flexDirection: 'row', height:"100%", width:"100%"}}>
 {/* <Typography fontFamily="Gilroy-Bold" fontSize="36px"  textAlign="center"> Coming Soon!!</Typography> */}
 <ComingSoonPage/>
    </Box>
    </Box>)
}
export default Prometheus;